module.exports = require("vue-ssr-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "vue-ssr-webpack-plugin"
// module id = 49
// module chunks = 0